import Header from "../navigation/header";
import {
  StyleSheet,
  TouchableOpacity,
  TextInput,
  Modal,
  ScrollView,
  ActivityIndicator,
  Switch,
  useWindowDimensions,
  Image,
  Pressable,
  Dimensions,
  Keyboard,
} from "react-native";
import DataTable from "react-data-table-component";
import { DataTable as DataTableNEW } from "react-native-paper";

import { RadioButton, Button } from "react-native-paper";
import moment from "moment";
import { TabView, SceneMap } from "react-native-tab-view";
import IconRefresh from "react-native-vector-icons/FontAwesome";

import { CheckBox } from "react-native-elements";
import AsyncStorage from "@react-native-async-storage/async-storage";

import { DatePickerModal } from "react-native-paper-dates";
import { Dropdown } from "react-native-element-dropdown";

import { Text, View } from "../../../components/Themed";

import Icon from "react-native-vector-icons/AntDesign";
import React, { useState, useRef, useEffect } from "react";
import IconCross from "react-native-vector-icons/Entypo";
import IconEdit from "react-native-vector-icons/FontAwesome";
import { baseUrl, postData } from "../../../networking/api";
import { useFocusEffect } from "@react-navigation/native";
import SuccessPopup from "../../../components/SuccessPopup";

export default function CreateFarmerProfile({ navigation }) {
  const [isVisible, setIsVisible] = useState(false);
  const [isEnabled, setIsEnabled] = useState(false);
  const [animating, setAnimating] = useState(true);
  const [isAdd, setisAdd] = useState(false);

  const [genderchecked, setGenderChecked] = useState(1);
  const [isMarriedchecked, setMaritialChecked] = useState(1);
  const [isstatuschecked, setStatusChecked] = useState(1);

  const [issuccessVisible, setissuccessVisible] = useState(false);
  const [responsestatus, setresponsestatus] = useState("");
  const [PopupMessage, setPopupMessage] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const [empCode, setEmpCode] = useState("");

  const [FarmerID, setFarmerID] = useState("");
  const [isFarmerIDValid, setFarmerIDValid] = useState(false);
  const [isFarmerIDEntered, setFarmerIDEntered] = useState(false);

  const [FarmerName, setFarmerName] = useState("");
  const [isFarmerNameValid, setFarmerNameValid] = useState(false);
  const [isFarmerNameEntered, setFarmerNameEntered] = useState(false);
  const [projectId, setProjectId] = useState("");

  const [EmailId, setEmailId] = useState("");
  const [isEmailIdValid, setEmailIdValid] = useState(false);
  const [isEmailIdEntered, setEmailIdEntered] = useState(false);

  const [MobileNumber, setMobileNumber] = useState("");
  const [isMobileNumberValid, setMobileNumberValid] = useState(false);
  const [isMobileNumberEntered, setMobileNumberEntered] = useState(false);

  const [OmegaIdData, setOmegaIdData] = useState([]);
  const [OmegavalueId, setOmegaValueiD] = useState("");
  const [OmegaDetails, setOmegaDetails] = useState([]);
  const [AnalogInput, setAnalogInput] = useState([]);
  const [DigitalInput, setDigitalInput] = useState([]);
  const [shouldShow, setShouldShow] = useState(false);

  const [OmegaIdValid, setOmegaIdValid] = useState(false);
  const [OmegaIdEntered, setOmegaIdEntered] = useState(false);

  const [CountryNameData, setCountryNameData] = useState([]);
  const [isCountryNameDataValid, setCountryNameDataValid] = useState(false);
  const [isCountryNameDataEntered, setCountryNameDataEntered] = useState(false);

  const [StateNameData, setStateNameData] = useState([]);
  const [isStateNameDataValid, setStateNameDataValid] = useState(false);
  const [isStateNameDataEntered, setStateNameDataEntered] = useState(false);

  const [CityNameData, setCityNameData] = useState([]);
  const [isCityNameDataValid, setCityNameDataValid] = useState(false);
  const [isCityNameDataEntered, setCityNameDataEntered] = useState(false);

  const [TahasilNameData, setTahasilNameData] = useState([]);
  const [isTahasilNameDataValid, setTahasilNameDataValid] = useState(false);
  const [isTahasilNameDataEntered, setTahasilNameDataEntered] = useState(false);

  const [VillageNameData, setVillageNameData] = useState([]);
  const [isVillageNameDataValid, setVillageNameDataValid] = useState(false);
  const [isVillageNameDataEntered, setVillageNameDataEntered] = useState(false);

  const [PinCode, setPinCode] = useState("");
  const [isPinCodeValid, setPinCodeValid] = useState(false);
  const [isPinCodeEntered, setPinCodeEntered] = useState(false);

  const [Address, setAddress] = useState("");
  const [isAddressValid, setAddressValid] = useState(false);
  const [isAddressEntered, setAddressEntered] = useState(false);

  const [KhasaraNumber, setKhasaraNum] = useState("");
  const [isKhasaraValid, setKhasaraValid] = useState(false);
  const [isKhasaraEntered, setKhasaraEntered] = useState(false);

  const [loginId, setloginId] = useState("");
  const [isloginIdValid, setloginIdValid] = useState(false);
  const [isloginIdEntered, setloginIdEntered] = useState(false);

  const [Password, setPassword] = useState("");
  const [isPasswordValid, setPasswordValid] = useState(false);
  const [isPasswordEntered, setPasswordEntered] = useState(false);

  const [isFocus, setIsFocus] = useState(false);

  const [countryValue, setCountryValue] = useState("");
  const [countryValId, setCountryValId] = useState("");
  const [stateValue, setStateValue] = useState("");
  const [stateValId, setStateValId] = useState("");
  const [cityValue, setCityValue] = useState("");
  const [cityValId, setCityValId] = useState("");
  const [tahasilValue, setTahasilValue] = useState("");
  const [tahasilValId, setTahasilValId] = useState("");
  const [VillageValue, setVillageValue] = useState("");
  const [VillageValId, setVillageValId] = useState("");
  const [KhasaraValue, setKhasaraValue] = useState("");
  const [KhasaraValId, setKhasaraValId] = useState("");

  const [OmegaIdValue, setOmegaIdValue] = useState(null);
  const [ValveName, setValveName] = useState(null);
  const [ValveIndex, setValveIndex] = useState(null);

  const [ValveId, setValveID] = useState("");

  const [FarmerNameError, setFarmerNameError] = useState("");
  const [emailIdError, setEmailIdError] = useState("");
  const [mobileNumError, setMobileNumError] = useState("");
  const [countryError, seTCountryError] = useState("");
  const [stateError, setStateError] = useState("");
  const [cityError, setCityError] = useState("");
  const [tahasilError, setTahasilError] = useState("");
  const [villageError, setVillageError] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const [pinError, setPinError] = useState("");
  const [khasaraError, setkhasaraError] = useState("");
  const [fieldId, setfieldId] = useState(0);

  const [fieldname, setfieldname] = useState("");
  const [Cultivated, setCultivated] = useState("");
  const [Water, setWater] = useState("");
  const [Crops, setCrops] = useState("");
  const [address, setaddress] = useState("");
  const [zone, setzone] = useState("");
  const [subZone, setSubZone] = useState("");
  const [devices, setDevice] = useState("");

  const [deviceRelationship, setdeviceRelationship] = useState(0);
  const [deviceRelationshipId, setdeviceRelationshipId] = useState();

  const [tableData, settableData] = useState([]);

  const [ProjectIdOmega, setProjectIdOmega] = useState("");
  const [CultivatedTotal, setCultivatedTotal] = useState(0);
  const [WaterTotal, setWaterTotal] = useState(0);
  const [cropsTotal, setcropsTotal] = useState(0);
  const [firstdata, setfirstdata] = useState([]);
  const [savedata, setsave] = useState(false);


  const [fieldnameError, setfieldnameError] = useState("");
  const [CultivatedError, setCultivatedError] = useState("");
  const [WaterError, setWaterError] = useState("");
  const [CropsError, setCropsError] = useState("");
  const [addressError, setaddressError] = useState("");
  const [OmegaError, setOmegaError] = useState("");
  const [valvesError, setValvesError] = useState("");

  

  const updateTableData = () => {
    const newFieldId = generateUniqueId(tableData);

    const newRow = {
      data: {
        field_id: newFieldId,
        khasara_number: fieldname,
        cultivated_area: Cultivated,
        water_demand: Water,
        crops: Crops,
        address: address,
        zone: zone,
        subZone: subZone,
        devices: devices,
        device_id: OmegavalueId,
        valve_id: ValveId,
        OmegaIdValue: OmegaIdValue,
        ValveName: ValveName,
        valve_index: ValveIndex,
        device_relationship: deviceRelationship,
        device_relationship_referance_id: deviceRelationshipId,
      },
    };

    setCultivatedTotal((prev) => prev + Number(Cultivated));
    setWaterTotal((prev) => prev + Number(Water));
    setcropsTotal((prev) => prev + Number(Crops));
    settableData((prevData) => [...prevData, newRow]);

    resetFormFields();
  };

  const resetFormFields = () => {
    setfieldname("");
    setCultivated("");
    setWater("");
    setCrops("");
    setaddress("");
    setzone("");
    setSubZone("");
    setDevice("");
    setOmegaIdValue(null);
    setOmegaValueiD("");
    setValveName(null);
    setValveIndex(null);
    setValveID("");
  };

  const [ActiveTab, setActiveTab] = useState(0);

  const dropdownRefcountry = useRef();
  const dropdownRefState = useRef();
  const dropdownRefCity = useRef();
  const dropdownRefTahasil = useRef();
  const dropdownRefVillage = useRef();
  const dropdownRefOmegaiD = useRef();

  const closeMenu = () => {
    dropdownRefcountry.current.close();
    dropdownRefState.current.close();
    dropdownRefCity.current.close();
    dropdownRefTahasil.current.close();
    dropdownRefVillage.current.close();
    dropdownRefOmegaiD.current.close();
  };

  useEffect(() => {
    window.addEventListener("scroll", closeMenu);
    return () => window.removeEventListener("scroll", closeMenu);
  }, []);


  useEffect(() => {
    getAllFarmerData();
    setCultivatedTotal(0);
    setWaterTotal(0);
    setcropsTotal(0);
    setsave(false);
  }, []);

  const getAllFarmerData = async () => {
    setIsLoading(true);
    try {
      var getFarmerData = JSON.stringify({
        module: "farmer_master",
        relation: [],
      });
      const FarmerNameResponse = await postData(
        getFarmerData,
        "masters/getMasterList",
      );
      setIsLoading(false);
      var code = FarmerNameResponse.code;
      if (code == 1) {
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error", error);
    }
  };

  const [index, setIndex] = React.useState(0);
  const [routes] = React.useState([
    { key: "DigitalOutput", title: "Digital Output" },
    { key: "AnalogInput", title: "Analog Input" },
    { key: "DigitalInput", title: "Digital Input" },
  ]);

  const [date, setDate] = React.useState<date | undefined>(undefined);
  const [open, setOpen] = React.useState(false);

  const [joinDate, setJoinDate] = React.useState<date | undefined>(undefined);
  const [joinOpen, setJoinOpen] = React.useState(false);

  var alpha_pattern = new RegExp(/^[a-zA-Z]+(\s[a-zA-Z]+)?$/);
  var Email_Id_pattern = new RegExp(
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  );
  const regex = /^[0-9]*$/;

  useFocusEffect(
    React.useCallback(() => {
      getAdminData();

      getCountry();
    }, []),
  );

  useEffect(() => {
    var cultiTotal = 0;
    var waterTotal = 0;
    var cropsTotal = 0;
    for (let i = 0; i < tableData.length; i++) {
      cultiTotal = cultiTotal + Number(tableData[i].data.cultivated_area);
      waterTotal = waterTotal + Number(tableData[i].data.water_demand);
      cropsTotal = cropsTotal + Number(tableData[i].data.crops);
    }
    setCultivatedTotal(cultiTotal);
    setWaterTotal(waterTotal);
    setcropsTotal(cropsTotal);
  }, [tableData]);

  const getAdminData = async () => {
    let jsonValue = await AsyncStorage.getItem("userData");

    let projValue = await AsyncStorage.getItem("projectData");

    if (projValue != null) {
      setProjectId(projValue);
      getOmegaDependentByProjectId(projValue);
    } else if (jsonValue != null) {
      var userDetailsresponse = JSON.parse(jsonValue);

      setloginId(userDetailsresponse.email_id);
      setEmpCode(userDetailsresponse.employee_code);
      setProjectId(userDetailsresponse.project_selected);

      getOmegaDependentByProjectId(userDetailsresponse.project_selected);
    }
  };
  const getCountry = async () => {
    setIsLoading(true);
    try {
      var countryData = JSON.stringify({
        module: "country_master",
        data: {
          active: 1,
        },
        relation: [],
      });
      const countryNameResponse = await postData(
        countryData,
        "masters/getMasterList",
      );
      setIsLoading(false);
      var code = countryNameResponse.code;
      if (code == 1) {
        setCountryNameData(countryNameResponse.data);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error", error);
    }
  };

  const customStyles = {
    rows: {
      style: {
        minHeight: "30px", 
      },
    },
    headRow: {
      style: {
        borderTopStyle: "solid",
        borderTopWidth: "1px",
        backgroundColor: "#319ef0a3",
        minHeight: "40px",
        fontSize: 16,
        fontWeight: "600",
      },
    },
    headCells: {
      style: {
        justifyContent: "center",
        minHeight: "20px",

        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
        },
      },
    },
    cells: {
      style: {
        paddingLeft: "8px", 
        paddingRight: "8px",
        justifyContent: "center",

        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
          fontSize: 16,
          fontWeight: "400",
        },
      },
    },
  };
  const columns = [
    {
      name: "Output number",
      selector: (row) => row.value,
      sortable: true,
    },
    {
      name: "Output Name",
      selector: (row) => row.name,
      sortable: true,
    },
    
  ];
  const columnsAnalog = [
    
    {
      name: "Output number",
      selector: (row) => row.value,
      sortable: true,
    },
    {
      name: "Output Name",
      selector: (row) => row.name,
      sortable: true,
    },
  ];

  const columnDigitalInput = [
    {
      name: "Output number",
      selector: (row) => row.value,
      sortable: true,
    },
    {
      name: "Output Name",
      selector: (row) => row.name,
      sortable: true,
    },
  ];

  const renderOmegaIdListItems = (item: any) => {
    return (
      <View style={styles.item}>
        {isAdd == true && (
          <Text style={styles.textItem}>{item.device_name}</Text>
        )}
        {isAdd == false && (
          <Text style={styles.textItem}>{item.device_name}</Text>
        )}
        {item.id === OmegavalueId && (
          <Icon style={styles.icon} color="black" name="Safety" size={20} />
        )}
      </View>
    );
  };

  const renderValveIdListItems = (item: any) => {
    return (
      <View style={styles.item}>
        {isAdd == true && <Text style={styles.textItem}>{item.name}</Text>}
        {isAdd == false && <Text style={styles.textItem}>{item.name}</Text>}
        {item.id === ValveId && (
          <Icon style={styles.icon} color="black" name="Safety" size={20} />
        )}
      </View>
    );
  };

  const renderCountryList = (item: any) => {
    return (
      <View style={styles.item}>
        {isAdd == true && <Text style={styles.textItem}>{item.country}</Text>}
        {isAdd == false && <Text style={styles.textItem}>{item.country}</Text>}
        {item.id === countryValId && (
          <Icon style={styles.icon} color="black" name="Safety" size={20} />
        )}
      </View>
    );
  };
  const renderStateListItems = (item) => {
    return (
      <View style={styles.item}>
        {isAdd == true && <Text style={styles.textItem}>{item.state}</Text>}
        {isAdd == false && <Text style={styles.textItem}>{item.state}</Text>}
        {item.id === stateValId && (
          <Icon style={styles.icon} color="black" name="Safety" size={20} />
        )}
      </View>
    );
  };
  const renderCityListItems = (item) => {
    return (
      <View style={styles.item}>
        {isAdd == true && <Text style={styles.textItem}>{item.city}</Text>}
        {isAdd == false && <Text style={styles.textItem}>{item.city}</Text>}
        {item.id === cityValId && (
          <Icon style={styles.icon} color="black" name="Safety" size={20} />
        )}
      </View>
    );
  };
  const renderTahasilListItems = (item) => {
    return (
      <View style={styles.item}>
        {isAdd == true && (
          <Text style={styles.textItem}>{item.tahasil_name}</Text>
        )}
        {isAdd == false && (
          <Text style={styles.textItem}>{item.tahasil_name}</Text>
        )}
        {item.id === tahasilValId && (
          <Icon style={styles.icon} color="black" name="Safety" size={20} />
        )}
      </View>
    );
  };
  const renderVillageListItems = (item) => {
    return (
      <View style={styles.item}>
        {isAdd == true && (
          <Text style={styles.textItem}>{item.village_name}</Text>
        )}
        {isAdd == false && (
          <Text style={styles.textItem}>{item.village_name}</Text>
        )}
        {item.id === VillageValId && (
          <Icon style={styles.icon} color="black" name="Safety" size={20} />
        )}
      </View>
    );
  };

  const CheckEnteredData = async () => {
    if (FarmerName == "") {
      setFarmerNameError("Please enter first name");
    }
    if (EmailId == "") {
      setEmailIdError("Please enter email id");
    }
    if (Password == "") {
      setPasswordError("Please enter password ");
    }

    if (OmegavalueId == "") {
      setOmegaError("Please select Omega Type");
    }
    if (PinCode == "") {
      setPinError("Please enter pin");
    }
    if (KhasaraNumber == "") {
      setkhasaraError("Please enter Khasara ");
    } else {
      setkhasaraError("");
    }

    if (fieldname == "") {
      setfieldnameError("Please enter field name");
    } else {
      setfieldnameError("");
    }
    if (Cultivated == "") {
      setCultivatedError("Please enter cultivated area");
    } else {
      setCultivatedError("");
    }


    if (Water == "") {
      setWaterError("Please enter water");
    } else {
      setWaterError("");
    }

    if (address == "") {
      setaddressError("Please enter field name");
    } else {
      setaddressError("");
    }
    if (ValveId == "") {
      setValvesError("Please select valves");
    } else {
      setValvesError("");
    }

    if (FarmerName != "" && EmailId != "" && Password != "" && PinCode != "") {
      setfieldnameError("");
      setCultivatedError("");
      setWaterError("");
      setCropsError("");
      setValvesError("");
      setaddressError("");
      setsave(true);

      return true;
    } else {
      return false;
    }
  };

  const getOmegaDetails = async (deviceId) => {
    setIsLoading(true);
    try {
      var OmegaDetails = JSON.stringify({
        device_id: deviceId,
      });
      const OmegaDetailsResponse = await postData(
        OmegaDetails,
        "masters/getOmegaDetails",
      );
      setIsLoading(false);
      var code = OmegaDetailsResponse.code;
      if (code == 1) {
        setShouldShow(false);
        setOmegaDetails(OmegaDetailsResponse.data[0].valves);
        setAnalogInput(OmegaDetailsResponse.data[0].analogInput);
        setDigitalInput(OmegaDetailsResponse.data[0].digitalInput);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error", error);
    }
  };

  const getZoneSubZone = async (deviceId) => {
    setIsLoading(true);
    setzone("");
    setSubZone("");
    setDevice("");
    setdeviceRelationship(0);
    setdeviceRelationshipId();
    try {
      var OmegaDetails = JSON.stringify({
        device_id: deviceId,
      });
      const OmegaDetailsResponse = await postData(
        OmegaDetails,
        "masters/getDeviceDetails",
      );
      setIsLoading(false);
      var code = OmegaDetailsResponse.code;
      if (code == 1) {
        if (OmegaDetailsResponse.data[0].type == 1) {
          setDevice(OmegaDetailsResponse.data[0].name);
          setdeviceRelationship(OmegaDetailsResponse.data[0].type);
          setdeviceRelationshipId(OmegaDetailsResponse.data[0].id);
        }
        if (OmegaDetailsResponse.data[0].type == 2) {
          setzone(OmegaDetailsResponse.data[0].name);
          setdeviceRelationship(OmegaDetailsResponse.data[0].type);
          setdeviceRelationshipId(OmegaDetailsResponse.data[0].id);
        }
        if (OmegaDetailsResponse.data[0].type == 3) {
          setSubZone(OmegaDetailsResponse.data[0].name);
          setdeviceRelationship(OmegaDetailsResponse.data[0].type);
          setdeviceRelationshipId(OmegaDetailsResponse.data[0].id);
        }
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error", error);
    }
  };

  const getOmegaDependentByProjectId = async (project_id) => {
    setIsLoading(true);
    try {
      var OmegaIdData = JSON.stringify({
        column: "project_id",
        value: project_id,
        module: "devices_master",
      });
      const OmegaIdList = await postData(
        OmegaIdData,
        "masters/getDependentMasterList",
      );
      setIsLoading(false);
      var code = OmegaIdList.code;
      if (code == 1) {
        setOmegaIdData(OmegaIdList.data);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error", error);
    }
  };
  const getDependentCountryMaster = async (country_id) => {
    setIsLoading(true);
    try {
      var dependentData = JSON.stringify({
        column: "country_id",
        value: country_id,
        module: "state_master",
      });
      const dependentCountryDataResponse = await postData(
        dependentData,
        "masters/getDependentMasterList",
      );
      setIsLoading(false);
      var code = dependentCountryDataResponse.code;
      if (code == 1) {
        setIsLoading(false);
        setStateNameData(dependentCountryDataResponse.data);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error", error);
    }
  };

  const getDependentStateMaster = async (state_id) => {
    setIsLoading(true);
    try {
      var dependentData = JSON.stringify({
        column: "state_id",
        value: state_id,
        module: "city_master",
      });
      const dependentStateDataResponse = await postData(
        dependentData,
        "masters/getDependentMasterList",
      );
      setIsLoading(false);
      var code = dependentStateDataResponse.code;
      if (code == 1) {
        setCityNameData(dependentStateDataResponse.data);
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error", error);
    }
  };

  const getDependentCityMaster = async (city_id) => {
    setIsLoading(true);
    try {
      var dependentData = JSON.stringify({
        column: "city_id",
        value: city_id,
        module: "tahasil_master",
      });
      const dependentCityDataResponse = await postData(
        dependentData,
        "masters/getDependentMasterList",
      );
      setIsLoading(false);
      var code = dependentCityDataResponse.code;
      if (code == 1) {
        setTahasilNameData(dependentCityDataResponse.data);
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error", error);
    }
  };

  const getDependentTahasilMaster = async (tahasil_id) => {
    setIsLoading(true);
    try {
      var dependentData = JSON.stringify({
        column: "tahasil_id",
        value: tahasil_id,
        module: "village_master",
      });
      const dependentTahasilDataResponse = await postData(
        dependentData,
        "masters/getDependentMasterList",
      );
      setIsLoading(false);
      var code = dependentTahasilDataResponse.code;
      if (code == 1) {
        setVillageNameData(dependentTahasilDataResponse.data);
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error", error);
    }
  };

  const createFarmerProfileData = async () => {
    CheckEnteredData();
    if (!savedata) {
      return;
    }

    setIsLoading(true);
    try {
      const farmerDetails =
        tableData.length > 0
          ? tableData.map((item) => item.data)
          : fieldname
            ? [
                {
                  field_id: generateUniqueId([]),
                  khasara_number: fieldname,
                  cultivated_area: Cultivated,
                  water_demand: Water,
                  crops: Crops,
                  address: address,
                  zone: zone,
                  sub_zone: subZone,
                  device: devices,
                  device_id: OmegavalueId,
                  valve_id: ValveId,
                  device_relationship: deviceRelationship,
                  device_relationship_referance_id: deviceRelationshipId,
                },
              ]
            : [];

      var farmerMasterData = JSON.stringify({
        modelName: "farmer_master",
        passwordEncryptionFieldName: "password",
        inputData: {
          project_id: projectId,
          farmer_name: FarmerName,
          mobile_number: MobileNumber,
          email_id: EmailId,
          country_id: countryValId,
          state_id: stateValId,
          city_id: cityValId,
          tahasil_id: tahasilValId,
          village_id: VillageValId,
          pincode: PinCode,
          address: Address,
          username: MobileNumber,
          active: 1,
          farmer_details: farmerDetails,
        },
        relation: [{ modelName: "farmer_details" }],
        password: {
          field_name: "password",
          value: Password,
        },
      });

      const response = await postData(
        farmerMasterData,
        "masters/farmerCreateUpdate",
      );

      setIsLoading(false);
      setsave(false);

      if (response.code == 1) {
        setPopupMessage("Record Created Successfully");
        setresponsestatus("success");
        setissuccessVisible(true);

        setTimeout(() => {
          setissuccessVisible(false);
          navigation.navigate("FarmerProfile");
        }, 1500);
      } else {
        setPopupMessage(response.message || "Error while creating farmer");
        setresponsestatus("failed");
        setissuccessVisible(true);
      }
    } catch (error) {
      console.error("Error creating farmer:", error);
      setIsLoading(false);
      setPopupMessage("An error occurred while creating farmer");
      setresponsestatus("failed");
      setissuccessVisible(true);
    }
  };

  const screenwidth = Dimensions.get("window").width;
  const isMobile = screenwidth < 768;

  const generateUniqueId = (tableData) => {
    if (tableData.length === 0) return "F0101";

    const existingIds = tableData.map((item) => item.data.field_id);

    const maxId = Math.max(
      ...existingIds.map((id) => {
        const numPart = parseInt(id.replace("F", ""), 10);
        return isNaN(numPart) ? 0 : numPart;
      }),
    );

    const newNum = maxId + 101;
    return `F${newNum.toString().padStart(4, "0")}`;
  };

  return (
    <View style={{ paddingBottom: 5 }}>
      <SuccessPopup
        visible={issuccessVisible}
        PopupMessage={PopupMessage}
        Responsestatus={responsestatus}
        onChange={() => setissuccessVisible(false)}
      />

      <View style={styles.container}>
        <View
          style={
            isMobile
              ? { flexDirection: "row", width: "100%", marginTop: "-15%" }
              : { flexDirection: "row", width: "100%", marginTop: "0%" }
          }
        >
          <View style={{ flex: 4, margin: 10 }}>
            <Text style={styles.lableText}>
              Profile {">"}
              <Text onPress={() => navigation.navigate("FarmerProfile")}>
                {" "}
                Farmer Profile{" "}
              </Text>{" "}
              {">"} Create Farmer Profile
            </Text>
          </View>
         
        </View>

        <View style={[styles.card, { flexGrow: 1 }]}>
          <View
            style={[
              styles.shadowProp,
              {
                backgroundColor: "white",
                borderRadius: 8,
                paddingVertical: 0,
                paddingHorizontal: 25,
              },
            ]}
          >
            <View
              style={
                isMobile
                  ? {
                    }
                  : {
                      flex: 1,
                      justifyContent: "center",
                      flexDirection: "row",
                    }
              }
            >
              <View
                style={
                  isMobile
                    ? { flex: 1, marginTop: 10, marginLeft: "0%" }
                    : { flex: 1, marginTop: 10, marginLeft: "10%" }
                }
              >
                <View
                  style={{
                    borderRadius: 10,
                    padding: 10,
                  }}
                >
                  <Text style={styles.lableText}>Farmer Name</Text>
                  <TextInput
                    style={
                      isMobile
                        ? {
                            borderColor: "#c3c3c3",
                            width: "100%",
                            borderWidth: 1,
                            borderRadius: 4,
                            color: "#000",
                            padding: 10,
                            marginTop: 4,
                            marginBottom: 6,
                          }
                        : styles.input
                    }
                    placeholder="Enter Farmer name"
                    value={FarmerName}
                    onChangeText={(value) => {
                      setFarmerNameValid(false);
                      setFarmerName(value);
                      if (value.length == 0) {
                        setFarmerNameError("Please enter first name");
                      } else {
                        setFarmerNameValid(true);
                        setFarmerNameError("");
                      }
                    }}
                  />
                  <Text style={[styles.error_text]}>{FarmerNameError}</Text>
                  <Text style={styles.lableText}> Mobile no.</Text>
                  <TextInput
                    style={
                      isMobile
                        ? {
                            borderColor: "#c3c3c3",
                            width: "100%",
                            borderWidth: 1,
                            borderRadius: 4,
                            color: "#000",
                            padding: 10,
                            marginTop: 4,
                            marginBottom: 6,
                          }
                        : styles.input
                    }
                    placeholder="Enter Mobile Number"
                    maxLength={10}
                    keyboardType={"numeric"}
                    onChangeText={(value) => {
                      setMobileNumberValid(false);
                      setMobileNumber(value);
                      if (value.length == 0) {
                        setMobileNumError("Please enter mobile number");
                      } else if (!regex.test(value)) {
                        setMobileNumError("Please enter number only");
                      } else if (value.length > 0 && value.length <= 9) {
                        setMobileNumError("Please enter 10 digit number");
                      } else {
                        setMobileNumberValid(true);
                        setMobileNumError("");
                      }
                    }}
                  />
                  <Text style={[styles.error_text]}>{mobileNumError}</Text>
                  <Text style={styles.lableText}>Email Id</Text>
                  <TextInput
                    style={
                      isMobile
                        ? {
                            borderColor: "#c3c3c3",
                            width: "100%",
                            borderWidth: 1,
                            borderRadius: 4,
                            color: "#000",
                            padding: 10,
                            marginTop: 4,
                            marginBottom: 6,
                          }
                        : styles.input
                    }
                    placeholder="Enter Email id"
                    value={EmailId}
                    onChangeText={(value) => {
                      setEmailIdValid(false);
                      setEmailId(value.replace(/\s/g, ""));
                      if (value.length == 0) {
                        setEmailIdError("Please enter email id");
                      } else if (!Email_Id_pattern.test(value)) {
                        setEmailIdError("Please enter valid email id  ");
                      } else {
                        setEmailIdValid(true);
                        setEmailIdError("");
                      }
                    }}
                  />
                  <Text style={[styles.error_text]}>{emailIdError}</Text>
                  <Text style={styles.lableText}>Login</Text>
                  <TextInput
                    style={
                      isMobile
                        ? {
                            borderColor: "#c3c3c3",
                            width: "100%",
                            borderWidth: 1,
                            borderRadius: 4,
                            color: "#000",
                            padding: 10,
                            marginTop: 4,
                            marginBottom: 6,
                          }
                        : styles.input
                    }
                    placeholder="Enter login id"
                    value={MobileNumber}
                    editable={false}
                    onChangeText={(value) => {
                      setloginIdValid(false);

                      setloginId(value);

                      if (Email_Id_pattern.test(value)) {
                        setloginIdValid(true);

                      }
                    }}
                  />
                  <Text style={styles.lableText}>Password</Text>
                  <TextInput
                    placeholder="Enter Password"
                    placeholderColor="#F0F0F0"
                    style={
                      isMobile
                        ? {
                            borderColor: "#c3c3c3",
                            width: "100%",
                            borderWidth: 1,
                            borderRadius: 4,
                            color: "#000",
                            padding: 10,
                            marginTop: 4,
                            marginBottom: 6,
                          }
                        : styles.input
                    }
                    secureTextEntry={true}
                    onChangeText={(value) => {
                      setPasswordValid(false);
                      setPassword(value);
                      if (value.length == 0) {
                        setPasswordError("Please enter password");
                      } else {
                        setPasswordError("");
                        setPasswordValid(true);
                      }
                    }}
                  />{" "}
                  <Text style={[styles.error_text]}>{passwordError}</Text>
                  <Text style={styles.lableText}>Pin</Text>
                  <TextInput
                    style={
                      isMobile
                        ? {
                            borderColor: "#c3c3c3",
                            width: "100%",
                            borderWidth: 1,
                            borderRadius: 4,
                            color: "#000",
                            padding: 10,
                            marginTop: 4,
                            marginBottom: 6,
                          }
                        : styles.input
                    }
                    maxLength={6}
                    placeholder="Enter Pincode"
                    onChangeText={(value) => {
                      setPinCodeValid(false);
                      setPinCode(value);
                      if (value.length == 0) {
                        setPinError("Please enter pin");
                      } else if (!regex.test(value)) {
                        setPinError("Please enter number only");
                      } else if (value.length > 0 && value.length < 6) {
                        setPinError("Please enter 6 digit pin");
                      } else {
                        setPinError("");
                        setPinCodeValid(true);
                      }
                    }}
                  />
                  <Text style={[styles.error_text]}>{pinError}</Text>
                 
                </View>
               
              </View>
              <View
                style={
                  isMobile
                    ? {
                        marginTop: -20,
                        borderRadius: 10,
                        padding: 10,
                      }
                    : {
                        flex: 1,
                        marginTop: 53,
                        borderRadius: 10,
                        padding: 10,
                        margin: 7,
                      }
                }
              >
                <View
                  style={
                    {
                    }
                  }
                >
                  <Text style={styles.lableText}>Country</Text>
                  <Dropdown
                    ref={dropdownRefcountry}
                    style={
                      isMobile
                        ? {
                            borderColor: "#c3c3c3",
                            width: "100%",
                            borderWidth: 1,
                            borderRadius: 2,
                            height: 40,
                            outlineStyle: "none",
                            padding: 10,
                            marginTop: 5,
                            marginBottom: 5,
                          }
                        : styles.dropdown
                    }
                    placeholderStyle={styles.placeholderStyle}
                    selectedTextStyle={styles.selectedTextStyle}
                    inputSearchStyle={styles.inputSearchStyle}
                    iconStyle={styles.iconStyle}
                    data={CountryNameData}
                    search
                    maxHeight={300}
                    labelField="country"
                    valueField="country"
                    placeholder={"Select Country"}
                    searchPlaceholder="Search..."
                    value={countryValue}
                    onChange={(item) => {
                      setCountryValue(item.country);
                      setCountryValId(item.id);
                      seTCountryError("");
                      getDependentCountryMaster(item.id);
                    }}
                    renderItem={renderCountryList}
                  />
                  <Text style={[styles.error_text]}>{countryError}</Text>
                </View>
                <View
                  style={
                    {
                    }
                  }
                >
                  <Text style={styles.lableText}>State</Text>
                  <Dropdown
                    ref={dropdownRefState}
                    style={
                      isMobile
                        ? {
                            borderColor: "#c3c3c3",
                            width: "100%",
                            borderWidth: 1,
                            borderRadius: 2,
                            height: 40,
                            outlineStyle: "none",
                            padding: 10,
                            marginTop: 5,
                            marginBottom: 5,
                          }
                        : styles.dropdown
                    }
                    placeholderStyle={styles.placeholderStyle}
                    selectedTextStyle={styles.selectedTextStyle}
                    inputSearchStyle={styles.inputSearchStyle}
                    iconStyle={styles.iconStyle}
                    data={StateNameData}
                    search
                    maxHeight={300}
                    labelField="state"
                    valueField="state"
                    placeholder={!isFocus ? "Select State" : "...."}
                    searchPlaceholder="Search..."
                    value={stateValue}
                    onChange={(item) => {

                      setStateValue(item.state);
                      setStateValId(item.id);
                      setStateError("");
                      getDependentStateMaster(item.id);
                    }}
                    renderItem={renderStateListItems}
                  />
                  <Text style={[styles.error_text]}>{stateError}</Text>
                </View>
                <View>
                  <Text style={styles.lableText}>District / City</Text>
                  <Dropdown
                    ref={dropdownRefCity}
                    style={
                      isMobile
                        ? {
                            borderColor: "#c3c3c3",
                            width: "100%",
                            borderWidth: 1,
                            borderRadius: 2,
                            height: 40,
                            outlineStyle: "none",
                            padding: 10,
                            marginTop: 5,
                            marginBottom: 5,
                          }
                        : styles.dropdown
                    }
                    placeholderStyle={styles.placeholderStyle}
                    selectedTextStyle={styles.selectedTextStyle}
                    inputSearchStyle={styles.inputSearchStyle}
                    iconStyle={styles.iconStyle}
                    data={CityNameData}
                    search
                    maxHeight={300}
                    labelField="city"
                    valueField="city"
                    placeholder={!isFocus ? "Select City" : "...."}
                    searchPlaceholder="Search..."
                    value={cityValue}
                    onChange={(item) => {
                      setCityValue(item.city);
                      setCityValId(item.id);
                      setCityError("");
                      getDependentCityMaster(item.id);
                    }}
                    renderItem={renderCityListItems}
                  />
                  <Text style={[styles.error_text]}>{cityError}</Text>
                </View>
                <View>
                  <Text style={styles.lableText}>Tahasil</Text>
                  <Dropdown
                    ref={dropdownRefTahasil}
                    style={
                      isMobile
                        ? {
                            borderColor: "#c3c3c3",
                            width: "100%",
                            borderWidth: 1,
                            borderRadius: 2,
                            height: 40,
                            outlineStyle: "none",
                            padding: 10,
                            marginTop: 5,
                            marginBottom: 5,
                          }
                        : styles.dropdown
                    }
                    placeholderStyle={styles.placeholderStyle}
                    selectedTextStyle={styles.selectedTextStyle}
                    inputSearchStyle={styles.inputSearchStyle}
                    iconStyle={styles.iconStyle}
                    data={TahasilNameData}
                    search
                    maxHeight={300}
                    labelField="tahasil_name"
                    valueField="tahasil_name"
                    placeholder={!isFocus ? "Select Tahasil" : "...."}
                    searchPlaceholder="Search..."
                    value={tahasilValue}
                    onChange={(item) => {
                      setTahasilValue(item.tahasil_name);
                      setTahasilValId(item.id);
                      setTahasilError("");
                      getDependentTahasilMaster(item.id);
                    }}
                    renderItem={renderTahasilListItems}
                  />
                  <Text style={[styles.error_text]}>{tahasilError}</Text>
                </View>
                <View>
                  <Text style={styles.lableText}>Village</Text>
                  <Dropdown
                    ref={dropdownRefVillage}
                    style={
                      isMobile
                        ? {
                            borderColor: "#c3c3c3",
                            width: "100%",
                            borderWidth: 1,
                            borderRadius: 2,
                            height: 40,
                            outlineStyle: "none",
                            padding: 10,
                            marginTop: 5,
                            marginBottom: 5,
                          }
                        : styles.dropdown
                    }
                    placeholderStyle={styles.placeholderStyle}
                    selectedTextStyle={styles.selectedTextStyle}
                    inputSearchStyle={styles.inputSearchStyle}
                    iconStyle={styles.iconStyle}
                    data={VillageNameData}
                    search
                    maxHeight={300}
                    labelField="village_name"
                    valueField="village_name"
                    placeholder={!isFocus ? "Select Village" : "...."}
                    searchPlaceholder="Search..."
                    value={VillageValue}
                    onChange={(item) => {
                      setVillageValue(item.village_name);
                      setVillageValId(item.id);
                      setVillageError("");
                    }}
                    renderItem={renderVillageListItems}
                  />
                  <Text style={[styles.error_text]}>{villageError}</Text>
                </View>
              
                <Text style={styles.lableText}>Address </Text>
                <TextInput
                  multiline
                  numberOfLines={2}
                  style={
                    isMobile
                      ? {
                          borderColor: "#c3c3c3",
                          width: "100%",
                          borderWidth: 1,
                          borderRadius: 4,
                          color: "#000",
                          padding: 10,
                          marginTop: 4,
                          marginBottom: 6,
                        }
                      : [styles.input, { marginBottom: 0 }]
                  }
                  placeholder="Enter Address"
                  maxLength={500}
                  keyboardType="numeric"
                  onChangeText={(value) => {
                    setAddressValid(false);

                    setAddress(value);

                    if (alpha_pattern.test(value)) {
                      setAddressValid(true);

                    }
                  }}
                />{" "}
              </View>
            </View>

            
          </View>
        </View>
      </View>
      {shouldShow ? null : (
        <>
          <View style={{ flexDirection: "row", marginTop: 20 }}>
            <Pressable
              onPress={() => setActiveTab(0)}
              style={{
                backgroundColor: ActiveTab == 0 ? "#F6F9F9" : "white",
                borderTopLeftRadius: ActiveTab == 0 ? 10 : 0,
                borderTopRightRadius: ActiveTab == 0 ? 10 : 0,
                paddingHorizontal: 5,
                width: 150,
                alignItems: "center",
              }}
            >
              <Text style={{ marginVertical: 10 }}>Farmer Field Details</Text>
            </Pressable>
          </View>
          <View style={{ backgroundColor: "#F6F9F9" }}>
            <ScrollView horizontal>
              <DataTableNEW
                style={{ flex: 1, padding: 10, backgroundColor: "#F6F9F9" }}
              >
                <DataTableNEW.Header style={styles.tableHeader}>
                  <DataTableNEW.Title
                    style={{ flex: 0.08, justifyContent: "center" }}
                  >
                    <Text
                      style={{
                        fontSize: 14,
                        fontWeight: "600",
                      }}
                    >
                      Field Id
                    </Text>
                  </DataTableNEW.Title>
                  <DataTableNEW.Title
                    style={{ flex: 0.08, justifyContent: "center" }}
                  >
                    <Text
                      style={{
                        fontSize: 14,
                        fontWeight: "600",
                      }}
                    >
                      Field name
                    </Text>
                  </DataTableNEW.Title>
                  <DataTableNEW.Title
                    style={{ flex: 0.12, justifyContent: "center" }}
                  >
                    <Text
                      style={{
                        fontSize: 14,
                        fontWeight: "600",
                      }}
                    >
                      Cultivated area(Ha)
                    </Text>{" "}
                  </DataTableNEW.Title>
                  <DataTableNEW.Title
                    style={{ flex: 0.08, justifyContent: "center" }}
                  >
                    <Text
                      style={{
                        fontSize: 14,
                        fontWeight: "600",
                      }}
                    >
                      Water demand
                    </Text>
                    <Text> (m³)</Text>
                  </DataTableNEW.Title>
                  <DataTableNEW.Title
                    style={{ flex: 0.08, justifyContent: "center" }}
                  >
                    <Text
                      style={{
                        fontSize: 14,
                        fontWeight: "600",
                      }}
                    >
                      Crops
                    </Text>
                  </DataTableNEW.Title>
                  <DataTableNEW.Title
                    style={{ flex: 0.08, justifyContent: "center" }}
                  >
                    <Text
                      style={{
                        fontSize: 14,
                        fontWeight: "600",
                      }}
                    >
                      Address
                    </Text>
                  </DataTableNEW.Title>
                
                  <DataTableNEW.Title
                    style={{ flex: 0.1, justifyContent: "center" }}
                  >
                    <Text
                      style={{
                        fontSize: 14,
                        fontWeight: "600",
                      }}
                    >
                      Omega Value
                    </Text>
                  </DataTableNEW.Title>
                  <DataTableNEW.Title
                    style={{ flex: 0.1, justifyContent: "center" }}
                  >
                    <Text
                      style={{
                        fontSize: 14,
                        fontWeight: "600",
                      }}
                    >
                      Valve
                    </Text>
                  </DataTableNEW.Title>
                  <DataTableNEW.Title
                    style={{ flex: 0.09, justifyContent: "center" }}
                  >
                    <Text
                      style={{
                        fontSize: 14,
                        fontWeight: "600",
                      }}
                    >
                      Zone
                    </Text>
                  </DataTableNEW.Title>
                  <DataTableNEW.Title
                    style={{ flex: 0.09, justifyContent: "center" }}
                  >
                    <Text
                      style={{
                        fontSize: 14,
                        fontWeight: "600",
                      }}
                    >
                      Sub Zone
                    </Text>
                  </DataTableNEW.Title>
                  <DataTableNEW.Title
                    style={{ flex: 0.09, justifyContent: "center" }}
                  >
                    <Text
                      style={{
                        fontSize: 14,
                        fontWeight: "600",
                      }}
                    >
                      Device
                    </Text>
                  </DataTableNEW.Title>
                  <DataTableNEW.Title
                    style={{ flex: 0.12, justifyContent: "center" }}
                  >
                    <Text
                      style={{
                        fontSize: 14,
                        fontWeight: "600",
                      }}
                    >
                      Action
                    </Text>
                  </DataTableNEW.Title>
                </DataTableNEW.Header>

                {tableData.map((items, index) => {
                  return (
                    <DataTableNEW.Row style={{ flex: 1 }}>
                      <DataTableNEW.Cell
                        style={{ flex: 0.08, justifyContent: "center" }}
                      >
                        {items.data.field_id}
                      </DataTableNEW.Cell>
                      <DataTableNEW.Cell
                        style={{
                          flex: 0.08,
                          alignSelf: "center",
                          justifyContent: "center",
                        }}
                      >
                        <View
                          style={{ padding: 6, backgroundColor: "#f6f9f9" }}
                        >
                          <TextInput
                            value={items.data.khasara_number}
                            style={{
                              justifyContent: "center",
                              borderColor: "black",
                              width: "99%",
                              height: 40,
                              textAlign: "center",
                              borderWidth: 1,
                              backgroundColor: "transparent",
                            }}
                            onChangeText={(text) => {
                              setfieldnameError("");

                              settableData(
                                tableData.map((p) =>
                                  p.data.field_id === items.data.field_id
                                    ? {
                                        ...p,
                                        data: {
                                          farmer_id: p.data.farmer_id,
                                          field_id: p.data.field_id,
                                          khasara_number: text,
                                          cultivated_area:
                                            p.data.cultivated_area,
                                          water_demand: p.data.water_demand,
                                          crops: p.data.crops,
                                          address: p.data.address,
                                          zone: p.data.zone,
                                          subZone: p.data.subZone,
                                          devices: p.data.devices,
                                          OmegaIdValue: p.data.OmegaIdValue,
                                          device_id: p.data.device_id,
                                          ValveName: p.data.ValveName,
                                          valve_index: p.data.valve_index,
                                          valve_id: p.data.ValveId,
                                          device_relationship:
                                            p.data.device_relationship,
                                          device_relationship_referance_id:
                                            p.data
                                              .device_relationship_referance_id,
                                        },
                                      }
                                    : p,
                                ),
                              );
                            }}
                          />
                          <Text style={[styles.error_text1]}>
                            {fieldnameError}
                          </Text>
                        </View>
                      </DataTableNEW.Cell>

                      <DataTableNEW.Cell
                        style={{ flex: 0.08, justifyContent: "center" }}
                      >
                        <View
                          style={{ padding: 6, backgroundColor: "#f6f9f9" }}
                        >
                          <TextInput
                            value={items.data.cultivated_area}
                            keyboardType="numeric"
                            style={{
                              justifyContent: "center",
                              alignSelf: "flex-start",
                              borderColor: "black",
                              textAlign: "center",
                              width: "99%",
                              height: 40,
                              borderWidth: 1,
                              backgroundColor: "transparent",
                            }}
                            onChangeText={(text) => {
                              setCultivatedError("");
                              settableData(
                                tableData.map((p) =>
                                  p.data.field_id === items.data.field_id
                                    ? {
                                        ...p,
                                        data: {
                                          farmer_id: p.data.farmer_id,
                                          field_id: p.data.field_id,
                                          khasara_number: p.data.khasara_number,
                                          cultivated_area: text,
                                          water_demand: p.data.water_demand,
                                          crops: p.data.crops,
                                          address: p.data.address,
                                          zone: p.data.zone,
                                          subZone: p.data.subZone,
                                          OmegaIdValue: p.data.OmegaIdValue,
                                          device_id: p.data.device_id,
                                          ValveName: p.data.ValveName,
                                          valve_index: p.data.valve_index,
                                          valve_id: p.data.ValveId,
                                          device_relationship:
                                            p.data.device_relationship,
                                          device_relationship_referance_id:
                                            p.data
                                              .device_relationship_referance_id,
                                        },
                                      }
                                    : p,
                                ),
                              );
                            }}
                          />
                          <Text style={[styles.error_text1]}>
                            {CultivatedError}
                          </Text>
                        </View>
                      </DataTableNEW.Cell>

                      <DataTableNEW.Cell
                        style={{ flex: 0.08, justifyContent: "center" }}
                      >
                        <View
                          style={{ padding: 6, backgroundColor: "#f6f9f9" }}
                        >
                          <TextInput
                            value={items.data.water_demand}
                            keyboardType="numeric"
                            style={{
                              justifyContent: "center",
                              alignSelf: "flex-start",
                              borderColor: "black",
                              textAlign: "center",
                              width: "99%",
                              height: 40,
                              borderWidth: 1,
                              backgroundColor: "transparent",
                            }}
                            onChangeText={(text) => {
                              setWaterError("");
                              settableData(
                                tableData.map((p) =>
                                  p.data.field_id === items.data.field_id
                                    ? {
                                        ...p,
                                        data: {
                                          farmer_id: p.data.farmer_id,
                                          field_id: p.data.field_id,
                                          khasara_number: p.data.khasara_number,
                                          cultivated_area:
                                            p.data.cultivated_area,
                                          water_demand: text,
                                          crops: p.data.crops,
                                          address: p.data.address,
                                          zone: p.data.zone,
                                          subZone: p.data.subZone,
                                          devices: p.data.devices,
                                          OmegaIdValue: p.data.OmegaIdValue,
                                          device_id: p.data.device_id,
                                          ValveName: p.data.ValveName,
                                          valve_index: p.data.valve_index,
                                          valve_id: p.data.ValveId,
                                          device_relationship:
                                            p.data.device_relationship,
                                          device_relationship_referance_id:
                                            p.data
                                              .device_relationship_referance_id,
                                        },
                                      }
                                    : p,
                                ),
                              );
                            }}
                          />
                          <Text style={[styles.error_text1]}>{WaterError}</Text>
                        </View>
                      </DataTableNEW.Cell>

                      <DataTableNEW.Cell
                        style={{ flex: 0.08, justifyContent: "center" }}
                      >
                        <View
                          style={{ padding: 6, backgroundColor: "#f6f9f9" }}
                        >
                          <TextInput
                            value={items.data.crops}
                            keyboardType="numeric"
                            style={{
                              justifyContent: "center",
                              alignSelf: "flex-start",
                              borderColor: "black",
                              textAlign: "center",
                              width: "99%",
                              height: 40,
                              borderWidth: 1,
                              backgroundColor: "transparent",
                            }}
                            onChangeText={(text) => {
                              setCropsError("");
                              settableData(
                                tableData.map((p) =>
                                  p.data.field_id === items.data.field_id
                                    ? {
                                        ...p,
                                        data: {
                                          farmer_id: p.data.farmer_id,
                                          field_id: p.data.field_id,
                                          khasara_number: p.data.khasara_number,
                                          cultivated_area:
                                            p.data.cultivated_area,
                                          water_demand: p.data.water_demand,
                                          crops: text,
                                          address: p.data.address,
                                          zone: p.data.zone,
                                          subZone: p.data.subZone,
                                          devices: p.data.devices,
                                          OmegaIdValue: p.data.OmegaIdValue,
                                          device_id: p.data.device_id,
                                          ValveName: p.data.ValveName,
                                          valve_index: p.data.valve_index,
                                          valve_id: p.data.ValveId,
                                          device_relationship:
                                            p.data.device_relationship,
                                          device_relationship_referance_id:
                                            p.data
                                              .device_relationship_referance_id,
                                        },
                                      }
                                    : p,
                                ),
                              );
                            }}
                          />
                          <Text style={[styles.error_text1]}>{CropsError}</Text>
                        </View>
                      </DataTableNEW.Cell>

                      <DataTableNEW.Cell
                        style={{ flex: 0.08, justifyContent: "center" }}
                      >
                        <View
                          style={{ padding: 6, backgroundColor: "#f6f9f9" }}
                        >
                          <TextInput
                            value={items.data.address}
                            style={{
                              justifyContent: "center",
                              alignSelf: "flex-start",
                              borderColor: "black",
                              textAlign: "center",
                              width: "99%",
                              height: 40,
                              borderWidth: 1,
                              backgroundColor: "transparent",
                            }}
                            onChangeText={(text) => {
                              setaddressError("");
                              settableData(
                                tableData.map((p) =>
                                  p.data.field_id === items.data.field_id
                                    ? {
                                        ...p,
                                        data: {
                                          farmer_id: p.data.farmer_id,
                                          field_id: p.data.field_id,
                                          khasara_number: p.data.khasara_number,
                                          cultivated_area:
                                            p.data.cultivated_area,
                                          water_demand: p.data.water_demand,
                                          crops: p.data.crops,
                                          address: text,
                                          zone: p.data.zone,
                                          subZone: p.data.subZone,
                                          devices: p.data.devices,
                                          OmegaIdValue: p.data.OmegaIdValue,
                                          device_id: p.data.device_id,
                                          ValveName: p.data.ValveName,
                                          valve_index: p.data.valve_index,
                                          valve_id: p.data.ValveId,
                                          device_relationship:
                                            p.data.device_relationship,
                                          device_relationship_referance_id:
                                            p.data
                                              .device_relationship_referance_id,
                                        },
                                      }
                                    : p,
                                ),
                              );
                            }}
                          />
                          <Text style={[styles.error_text1]}>
                            {addressError}
                          </Text>
                        </View>
                      </DataTableNEW.Cell>
                      <DataTableNEW.Cell
                        style={{
                          flex: 0.4,
                          justifyContent: "center",
                          flexDirection: "row",
                        }}
                      >
                        <View
                          style={{ padding: 6, backgroundColor: "#f6f9f9" }}
                        >
                          <Dropdown
                            ref={dropdownRefOmegaiD}
                            style={{
                              borderColor: "#c3c3c3",
                              width: 150,
                              flex: 0.09,
                              borderWidth: 1,
                              borderRadius: 2,
                              justifyContent: "center",
                              height: 40,
                              marginBottom: 2,
                              padding: 10,
                            }}
                            placeholderStyle={{
                              fontSize: 12,
                            }}
                            selectedTextStyle={{
                              fontSize: 12,
                            }}
                            inputSearchStyle={{
                              fontSize: 13,
                            }}
                            iconStyle={styles.iconStyle}
                            data={OmegaIdData}
                            search
                            maxHeight={300}
                            labelField="device_name"
                            valueField="device_name"
                            placeholder={"Select"}
                            searchPlaceholder="Search..."
                            value={items.data.OmegaIdValue}
                            onChange={async (item) => {
                              setOmegaError("");
                              getOmegaDetails(item.id);
                              getZoneSubZone(item.id);
                              setzone("");
                              setSubZone("");
                              setDevice("");
                              setdeviceRelationship(0);
                              setdeviceRelationshipId();
                              settableData(
                                tableData.map((p) =>
                                  p.data.field_id === items.data.field_id
                                    ? {
                                        ...p,
                                        data: {
                                          farmer_id: p.data.farmer_id,
                                          field_id: p.data.field_id,
                                          khasara_number: p.data.khasara_number,
                                          cultivated_area:
                                            p.data.cultivated_area,
                                          water_demand: p.data.water_demand,
                                          crops: p.data.crops,
                                          address: p.data.address,
                                          zone: "",
                                          subZone: "",
                                          devices: "",
                                          OmegaIdValue: item.device_name,
                                          device_id: item.id,
                                          ValveName: p.data.ValveName,
                                          valve_index: p.data.valve_index,
                                          valve_id: p.data.ValveId,
                                          device_relationship: "",
                                          device_relationship_referance_id: "",
                                        },
                                      }
                                    : p,
                                ),
                              );
                              try {
                                var OmegaDetails = JSON.stringify({
                                  device_id: item.id,
                                });
                                const OmegaDetailsResponse = await postData(
                                  OmegaDetails,
                                  "masters/getZoneSubZone",
                                );
                                setIsLoading(false);
                                var code = OmegaDetailsResponse.code;
                                if (code == 1) {
                                  if (OmegaDetailsResponse.data[0].type == 2) {
                                    settableData(
                                      tableData.map((p) =>
                                        p.data.field_id === items.data.field_id
                                          ? {
                                              ...p,
                                              data: {
                                                farmer_id: p.data.farmer_id,
                                                field_id: p.data.field_id,
                                                khasara_number:
                                                  p.data.khasara_number,
                                                cultivated_area:
                                                  p.data.cultivated_area,
                                                water_demand:
                                                  p.data.water_demand,
                                                crops: p.data.crops,
                                                address: p.data.address,
                                                zone: OmegaDetailsResponse
                                                  .data[0].name,
                                                subZone: "",
                                                devices: "",
                                                OmegaIdValue: item.device_name,
                                                device_id: item.id,
                                                ValveName: p.data.ValveName,
                                                valve_index: p.data.valve_index,
                                                valve_id: p.data.ValveId,
                                                device_relationship:
                                                  OmegaDetailsResponse.data[0]
                                                    .type,
                                                device_relationship_referance_id:
                                                  OmegaDetailsResponse.data[0]
                                                    .id,
                                              },
                                            }
                                          : p,
                                      ),
                                    );
                                  }
                                  if (OmegaDetailsResponse.data[0].type == 3) {
                                    setSubZone(
                                      OmegaDetailsResponse.data[0].name,
                                    );
                                    setdeviceRelationship(
                                      OmegaDetailsResponse.data[0].type,
                                    );
                                    setdeviceRelationshipId(
                                      OmegaDetailsResponse.data[0].id,
                                    );
                                    settableData(
                                      tableData.map((p) =>
                                        p.data.field_id === items.data.field_id
                                          ? {
                                              ...p,
                                              data: {
                                                farmer_id: p.data.farmer_id,
                                                field_id: p.data.field_id,
                                                khasara_number:
                                                  p.data.khasara_number,
                                                cultivated_area:
                                                  p.data.cultivated_area,
                                                water_demand:
                                                  p.data.water_demand,
                                                crops: p.data.crops,
                                                address: p.data.address,
                                                zone: "",
                                                subZone:
                                                  OmegaDetailsResponse.data[0]
                                                    .name,
                                                devices: "",
                                                OmegaIdValue: item.device_name,
                                                device_id: item.id,
                                                ValveName: p.data.ValveName,
                                                valve_index: p.data.valve_index,
                                                valve_id: p.data.ValveId,
                                                device_relationship:
                                                  OmegaDetailsResponse.data[0]
                                                    .type,
                                                device_relationship_referance_id:
                                                  OmegaDetailsResponse.data[0]
                                                    .id,
                                              },
                                            }
                                          : p,
                                      ),
                                    );
                                  }
                                  if (OmegaDetailsResponse.data[0].type == 1) {
                                    setDevice(
                                      OmegaDetailsResponse.data[0].name,
                                    );
                                    setdeviceRelationship(
                                      OmegaDetailsResponse.data[0].type,
                                    );
                                    setdeviceRelationshipId(
                                      OmegaDetailsResponse.data[0].id,
                                    );
                                    settableData(
                                      tableData.map((p) =>
                                        p.data.field_id === items.data.field_id
                                          ? {
                                              ...p,
                                              data: {
                                                farmer_id: p.data.farmer_id,
                                                field_id: p.data.field_id,
                                                khasara_number:
                                                  p.data.khasara_number,
                                                cultivated_area:
                                                  p.data.cultivated_area,
                                                water_demand:
                                                  p.data.water_demand,
                                                crops: p.data.crops,
                                                address: p.data.address,
                                                zone: "",
                                                subZone: "",
                                                devices:
                                                  OmegaDetailsResponse.data[0]
                                                    .name,
                                                OmegaIdValue: item.device_name,
                                                device_id: item.id,
                                                ValveName: p.data.ValveName,
                                                valve_index: p.data.valve_index,
                                                valve_id: p.data.ValveId,
                                                device_relationship:
                                                  OmegaDetailsResponse.data[0]
                                                    .type,
                                                device_relationship_referance_id:
                                                  OmegaDetailsResponse.data[0]
                                                    .id,
                                              },
                                            }
                                          : p,
                                      ),
                                    );
                                  }
                                } else {
                                  setIsLoading(false);
                                }
                              } catch (error) {
                                setIsLoading(false);
                                console.error("Error", error);
                              }
                            }}
                            renderItem={renderOmegaIdListItems}
                          />
                          <Text style={[styles.error_text1]}>{OmegaError}</Text>
                        </View>
                        <View
                          style={{ padding: 6, backgroundColor: "#f6f9f9" }}
                        >
                          <Dropdown
                            ref={dropdownRefOmegaiD}
                            style={{
                              borderColor: "#c3c3c3",
                              width: 100,
                              flex: 0.09,
                              marginLeft: 5,
                              borderWidth: 1,
                              borderRadius: 2,
                              justifyContent: "center",
                              alignSelf: "flex-start",
                              height: 40,
                              padding: 10,
                            }}
                            placeholderStyle={{
                              fontSize: 12,
                            }}
                            selectedTextStyle={{
                              fontSize: 12,
                            }}
                            inputSearchStyle={{
                              height: 40,
                              fontSize: 13,
                            }}
                            iconStyle={styles.iconStyle}
                            data={OmegaDetails}
                            search
                            maxHeight={300}
                            labelField="name"
                            valueField="name"
                            placeholder={!isFocus ? "Select" : "...."}
                            searchPlaceholder="Search..."
                            value={items.data.ValveName}
                            onChange={(item) => {
                              setValvesError("");
                              setValveName("");
                              settableData(
                                tableData.map((p) =>
                                  p.data.field_id === items.data.field_id
                                    ? {
                                        ...p,
                                        data: {
                                          farmer_id: p.data.farmer_id,
                                          field_id: p.data.field_id,
                                          khasara_number: p.data.khasara_number,
                                          cultivated_area:
                                            p.data.cultivated_area,
                                          water_demand: p.data.water_demand,
                                          crops: p.data.crops,
                                          address: p.data.address,
                                          zone: p.data.zone,
                                          subZone: p.data.subZone,
                                          OmegaIdValue: p.data.OmegaIdValue,
                                          device_id: p.data.device_id,
                                          ValveName: item.name,
                                          valve_index: p.data.valve_index,
                                          valve_id: item.id,
                                          device_relationship:
                                            p.data.device_relationship,
                                          device_relationship_referance_id:
                                            p.data
                                              .device_relationship_referance_id,
                                        },
                                      }
                                    : p,
                                ),
                              );
                            }}
                            renderItem={renderValveIdListItems}
                          />
                          <Text style={[styles.error_text1]}>
                            {valvesError}
                          </Text>
                        </View>

                        <TextInput
                          value={items.data.zone}
                          placeholder={zone ? "" : "zone"}
                          style={{
                            marginHorizontal: 1,
                            justifyContent: "center",
                            alignSelf: "flex-start",
                            borderColor: "black",
                            width: 140,
                            marginLeft: 5,
                            borderRadius: 2,
                            marginTop: 2,
                            height: 40,
                            padding: 10,
                            textAlign: "center",
                            borderWidth: 1,
                            backgroundColor: "transparent",
                          }}
                        />

                        <TextInput
                          value={items.data.subZone}
                          placeholder={subZone ? "" : "Sub Zone"}
                          style={{
                            justifyContent: "center",
                            alignSelf: "flex-start",
                            borderColor: "black",
                            width: 80,
                            minWidth: 80,
                            marginLeft: 5,
                            borderRadius: 2,
                            height: 40,
                            padding: 10,
                            textAlign: "center",
                            borderWidth: 1,
                            backgroundColor: "transparent",
                          }}
                        />
                        <TextInput
                          value={items.data.devices}
                          placeholder={devices ? "" : "Device"}
                          style={{
                            justifyContent: "center",
                            alignSelf: "flex-start",
                            borderColor: "black",
                            width: 80,
                            minWidth: 80,
                            marginLeft: 5,
                            borderRadius: 2,
                            height: 40,
                            padding: 10,
                            textAlign: "center",
                            borderWidth: 1,
                            backgroundColor: "transparent",
                          }}
                        />
                      </DataTableNEW.Cell>
                      <DataTableNEW.Cell
                        style={{ flex: 0.12, justifyContent: "center" }}
                      >
                        <TouchableOpacity
                          onPress={() => {
                            setfieldname(items.data.khasara_number);
                            setCultivated(items.data.cultivated_area);
                            setWater(items.data.water_demand);
                            setCrops(items.data.crops);
                            setaddress(items.data.address);
                            setOmegaIdValue(items.data.OmegaIdValue);
                            setOmegaValueiD(items.data.device_id);
                            setValveName(items.data.ValveName);
                            setValveID(items.data.valve_id);
                            setzone(items.data.zone);
                            setSubZone(items.data.subZone);
                            setDevice(items.data.devices);
                            settableData(
                              tableData.filter(
                                (item) =>
                                  item.data.field_id !== items.data.field_id,
                              ),
                            );
                          }}
                        >
                          <IconEdit
                            name="pencil"
                            size={13}
                            color="#fff"
                            style={{
                              padding: 6,
                              backgroundColor: "#08588E",
                              borderRadius: 12,
                            }}
                          />
                        </TouchableOpacity>
                        <TouchableOpacity
                          onPress={() => {
                            updateTableData();
                          }}
                          style={{ marginHorizontal: 2 }}
                        >
                          <IconEdit
                            name="plus"
                            size={13}
                            color="#fff"
                            style={{
                              padding: 6,
                              backgroundColor: "#7CA53C",
                              borderRadius: 12,
                            }}
                          />
                        </TouchableOpacity>
                        <TouchableOpacity
                          onPress={() =>
                            settableData(
                              tableData.filter(
                                (item) =>
                                  item.data.field_id !== items.data.field_id,
                              ),
                            )
                          }
                        >
                          <IconEdit
                            name="trash-o"
                            size={14}
                            color="#fff"
                            style={{
                              padding: 6,
                              backgroundColor: "#FF0000",
                              borderRadius: 12,
                            }}
                          />
                        </TouchableOpacity>
                      </DataTableNEW.Cell>
                    </DataTableNEW.Row>
                  );
                })}
                {tableData.length > 0 ? null : (
                  <DataTableNEW.Row style={{ flex: 1 }}>
                    <DataTableNEW.Cell
                      style={{ flex: 0.08, justifyContent: "center" }}
                    >
                      {tableData.length > 0
                        ? tableData.length < 9
                          ? `F0${tableData.length + 1}0${tableData.length + 1}`
                          : `F${tableData.length + 1}${tableData.length + 1}`
                        : "F0101"}
                    </DataTableNEW.Cell>
                    <DataTableNEW.Cell
                      style={{
                        flex: 0.08,
                        alignSelf: "center",
                        justifyContent: "center",
                      }}
                    >
                      <View style={{ padding: 6, backgroundColor: "#f6f9f9" }}>
                        <TextInput
                          value={fieldname}
                          style={{
                            justifyContent: "center",
                            borderColor: "black",
                            width: "99%",
                            height: 40,
                            textAlign: "center",
                            borderWidth: 1,
                            backgroundColor: "transparent",
                          }}
                          onChangeText={(text) => {
                            setfieldname(text);
                            setfieldnameError("");
                          }}
                        />
                        <Text style={[styles.error_text1]}>
                          {fieldnameError}
                        </Text>
                      </View>
                    </DataTableNEW.Cell>

                    <DataTableNEW.Cell
                      style={{ flex: 0.08, justifyContent: "center" }}
                    >
                      <View style={{ padding: 6, backgroundColor: "#f6f9f9" }}>
                        <TextInput
                          value={Cultivated}
                          keyboardType="numeric"
                          style={{
                            justifyContent: "center",
                            alignSelf: "flex-start",
                            borderColor: "black",
                            textAlign: "center",
                            width: "99%",
                            height: 40,
                            borderWidth: 1,
                            backgroundColor: "transparent",
                          }}
                          onChangeText={(text) => {
                            setCultivated(text);
                            setCultivatedError("");
                          }}
                        />
                        <Text style={[styles.error_text1]}>
                          {CultivatedError}
                        </Text>
                      </View>
                    </DataTableNEW.Cell>

                    <DataTableNEW.Cell
                      style={{ flex: 0.08, justifyContent: "center" }}
                    >
                      <View style={{ padding: 6, backgroundColor: "#f6f9f9" }}>
                        <TextInput
                          value={Water}
                          keyboardType="numeric"
                          style={{
                            justifyContent: "center",
                            alignSelf: "flex-start",
                            borderColor: "black",
                            textAlign: "center",
                            width: "99%",
                            height: 40,
                            borderWidth: 1,
                            backgroundColor: "transparent",
                          }}
                          onChangeText={(text) => {
                            setWater(text);
                            setWaterError("");
                          }}
                        />
                        <Text style={[styles.error_text1]}>{WaterError}</Text>
                      </View>
                    </DataTableNEW.Cell>

                    <DataTableNEW.Cell
                      style={{ flex: 0.08, justifyContent: "center" }}
                    >
                      <View style={{ padding: 6, backgroundColor: "#f6f9f9" }}>
                        <TextInput
                          value={Crops}
                          keyboardType="numeric"
                          style={{
                            justifyContent: "center",
                            alignSelf: "flex-start",
                            borderColor: "black",
                            textAlign: "center",
                            width: "99%",
                            height: 40,
                            borderWidth: 1,
                            backgroundColor: "transparent",
                          }}
                          onChangeText={(text) => {
                            setCrops(text);
                            setCropsError("");
                          }}
                        />
                        <Text style={[styles.error_text1]}>{CropsError}</Text>
                      </View>
                    </DataTableNEW.Cell>

                    <DataTableNEW.Cell
                      style={{ flex: 0.08, justifyContent: "center" }}
                    >
                      <View style={{ padding: 6, backgroundColor: "#f6f9f9" }}>
                        <TextInput
                          value={address}
                          style={{
                            justifyContent: "center",
                            alignSelf: "flex-start",
                            borderColor: "black",
                            textAlign: "center",
                            width: "99%",
                            height: 40,
                            borderWidth: 1,
                            backgroundColor: "transparent",
                          }}
                          onChangeText={(text) => {
                            setaddress(text);
                            setaddressError("");
                          }}
                        />
                        <Text style={[styles.error_text1]}>{addressError}</Text>
                      </View>
                    </DataTableNEW.Cell>
                    <DataTableNEW.Cell
                      style={{
                        flex: 0.4,
                        justifyContent: "center",
                        flexDirection: "row",
                        alignSelf: "center",
                      }}
                    >
                      <View style={{ padding: 6, backgroundColor: "#f6f9f9" }}>
                        <Dropdown
                          ref={dropdownRefOmegaiD}
                          style={{
                            borderColor: "#c3c3c3",
                            width: 150,
                            flex: 0.09,
                            borderWidth: 1,
                            borderRadius: 2,
                            alignSelf: "center",
                            height: 40,
                            marginBottom: 2,
                            padding: 10,
                          }}
                          placeholderStyle={{
                            fontSize: 12,
                          }}
                          selectedTextStyle={{
                            fontSize: 12,
                          }}
                          inputSearchStyle={{
                            height: 40,
                            fontSize: 13,
                          }}
                          iconStyle={styles.iconStyle}
                          data={OmegaIdData}
                          search
                          maxHeight={300}
                          labelField="device_name"
                          valueField="device_name"
                          placeholder={!isFocus ? "Select Device Name" : "...."}
                          searchPlaceholder="Search..."
                          value={OmegaIdValue}
                          onChange={(item) => {
                            setOmegaIdValue(item.device_name);
                            setOmegaValueiD(item.id);
                            setOmegaError("");
                            getOmegaDetails(item.id);
                            setProjectIdOmega(item.project_id);
                            getZoneSubZone(item.id);
                          }}
                          renderItem={renderOmegaIdListItems}
                        />
                        <Text style={[styles.error_text1]}>{OmegaError}</Text>
                      </View>
                      <View style={{ padding: 6, backgroundColor: "#f6f9f9" }}>
                        <Dropdown
                          ref={dropdownRefOmegaiD}
                          style={{
                            borderColor: "#c3c3c3",
                            width: 100,
                            flex: 0.09,
                            marginLeft: 5,
                            borderWidth: 1,
                            borderRadius: 2,
                            alignSelf: "flex-start",
                            height: 40,
                            padding: 10,
                          }}
                          placeholderStyle={{
                            fontSize: 12,
                          }}
                          selectedTextStyle={{
                            fontSize: 12,
                          }}
                          inputSearchStyle={{
                            height: 40,
                            fontSize: 13,
                          }}
                          iconStyle={styles.iconStyle}
                          data={OmegaDetails}
                          search
                          maxHeight={300}
                          labelField="name"
                          valueField="name"
                          placeholder={!isFocus ? "Select Valve" : "...."}
                          searchPlaceholder="Search..."
                          value={ValveName}
                          onChange={(item) => {
                            setValveName(item.name);
                            setValveIndex(item.index);
                            setValveID(item.id);
                            setValvesError("");
                          }}
                          renderItem={renderValveIdListItems}
                        />
                        <Text style={[styles.error_text1]}>{valvesError}</Text>
                      </View>
                      <TextInput
                        value={zone}
                        placeholder="zone"
                        editable={false}
                        style={{
                          marginHorizontal: 1,
                          justifyContent: "center",
                          alignSelf: "flex-start",
                          borderColor: "black",
                          width: 140,
                          marginLeft: 10,
                          marginRight: 5,
                          borderRadius: 2,
                          marginTop: 2,
                          height: 40,
                          padding: 10,
                          textAlign: "center",
                          borderWidth: 1,
                          backgroundColor: "transparent",
                        }}
                      />
                      <TextInput
                        value={subZone}
                        placeholder="Sub zone"
                        editable={false}
                        style={{
                          justifyContent: "center",
                          alignSelf: "center",
                          borderColor: "black",
                          width: 80,
                          marginLeft: 10,
                          marginRight: 5,
                          borderRadius: 2,
                          height: 40,
                          padding: 10,
                          textAlign: "center",
                          borderWidth: 1,
                          backgroundColor: "transparent",
                        }}
                      />
                      <TextInput
                        value={devices}
                        placeholder="Device"
                        editable={false}
                        style={{
                          justifyContent: "center",
                          alignSelf: "center",
                          borderColor: "black",
                          width: 80,
                          marginLeft: 5,
                          borderRadius: 2,
                          height: 40,
                          padding: 10,
                          textAlign: "center",
                          borderWidth: 1,
                          backgroundColor: "transparent",
                        }}
                      />
                      
                    </DataTableNEW.Cell>
                    <DataTableNEW.Cell
                      style={{
                        flex: 0.12,
                        justifyContent: "center",
                        alignSelf: "center",
                      }}
                    >
                      <TouchableOpacity onPress={() => {}}>
                        <IconEdit
                          name="pencil"
                          size={13}
                          color="#fff"
                          style={{
                            padding: 6,
                            backgroundColor: "#08588E",
                            borderRadius: 12,
                          }}
                        />
                      </TouchableOpacity>
                      <TouchableOpacity
                        onPress={() => {
                          updateTableData();
                        }}
                        style={{ marginHorizontal: 2 }}
                      >
                        <IconEdit
                          name="plus"
                          size={13}
                          color="#fff"
                          style={{
                            padding: 6,
                            backgroundColor: "#7CA53C",
                            borderRadius: 12,
                          }}
                        />
                      </TouchableOpacity>
                      <TouchableOpacity
                        onPress={() => {
                          setfieldname("");
                          setCultivated("");
                          setWater("");
                          setCrops("");
                          setaddress("");
                          setzone("");
                          setSubZone("");
                          setDevice("");
                          setOmegaValueiD("");
                          setValveID("");
                          setValveName(null);
                          setValveIndex(null);
                          setOmegaIdValue(null);
                          setdeviceRelationship(0);
                          setdeviceRelationshipId();
                        }}
                      >
                        <IconEdit
                          name="trash-o"
                          size={14}
                          color="#fff"
                          style={{
                            padding: 6,
                            backgroundColor: "#FF0000",
                            borderRadius: 12,
                          }}
                        />
                      </TouchableOpacity>
                    </DataTableNEW.Cell>
                  </DataTableNEW.Row>
                )}

                <DataTableNEW.Header style={{ backgroundColor: "transparent" }}>
                  <DataTableNEW.Title
                    style={{ flex: 0.08, justifyContent: "center" }}
                  >
                    Total
                  </DataTableNEW.Title>
                  <DataTableNEW.Title
                    style={{ flex: 0.08, justifyContent: "center" }}
                  >
                    Total: {tableData ? tableData.length : 0}
                  </DataTableNEW.Title>
                  <DataTableNEW.Title
                    style={{ flex: 0.08, justifyContent: "center" }}
                  >
                    Total: {CultivatedTotal ? CultivatedTotal : 0}
                  </DataTableNEW.Title>
                  <DataTableNEW.Title
                    style={{ flex: 0.08, justifyContent: "center" }}
                  >
                    Total:{WaterTotal ? WaterTotal : 0}{" "}
                  </DataTableNEW.Title>
                  <DataTableNEW.Title
                    style={{ flex: 0.08, justifyContent: "center" }}
                  >
                    Total:{cropsTotal ? cropsTotal : 0}{" "}
                  </DataTableNEW.Title>
                  <DataTableNEW.Title
                    style={{ flex: 0.08, justifyContent: "center" }}
                  >
                    Total: {tableData ? tableData.length : 0}
                  </DataTableNEW.Title>
                  <DataTableNEW.Title
                    style={{ flex: 0.1, justifyContent: "center" }}
                  >
                    Total: {tableData ? tableData.length : 0}
                  </DataTableNEW.Title>
                  <DataTableNEW.Title
                    style={{ flex: 0.1, justifyContent: "center" }}
                  >
                    Total: {tableData ? tableData.length : 0}
                  </DataTableNEW.Title>
                  <DataTableNEW.Title
                    style={{ flex: 0.1, justifyContent: "center" }}
                  >
                    Total: {tableData ? tableData.length : 0}
                  </DataTableNEW.Title>
                  <DataTableNEW.Title
                    style={{ flex: 0.1, justifyContent: "center" }}
                  >
                    Total: {tableData ? tableData.length : 0}
                  </DataTableNEW.Title>
                </DataTableNEW.Header>
              </DataTableNEW>
            </ScrollView>
          </View>
        </>
      )}
      <View
        style={{
          flexDirection: "row",
          justifyContent: "center",
          marginHorizontal: 20,
          marginVertical: 10,
        }}
      >
        <TouchableOpacity
          style={styles.saveBtn}
          onPress={() => {
            createFarmerProfileData();
          }}
        >
          <Text style={styles.btnText}>Save</Text>
        </TouchableOpacity>

        <TouchableOpacity
          style={styles.saveBtn}
          onPress={() => navigation.navigate("FarmerProfile")}
        >
          <Text style={styles.btnText}>Cancel</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    padding: 15,
  },
  tableHeader: {
    backgroundColor: "#319ef0a3",
  },
  genderNames: {
    margin: 7,
  },
  statusNames: {
    margin: 7,
  },
  containeralt: {
    backgroundColor: "white",
    borderColor: "#eee",
    borderRadius: 10,
    borderWidth: 1,
    height: "100%",
    marginRight: "10%",
    marginTop: "0%",
    margin: "auto",
    padding: 30,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
    width: "70%",
  },
  input: {
    borderColor: "#c3c3c3",
    width: "70%",
    borderWidth: 1,
    borderRadius: 4,
    color: "#000",
    padding: 10,
    marginTop: 4,
    marginBottom: 6,
  },
  title: {
    fontSize: 20,
    fontWeight: "bold",
  },
  addCountry: {
    alignItems: "center",
    backgroundColor: "#006EB9",
    padding: 10,
    borderWidth: 1,
    borderColor: "#006EB9",
    width: "70%",
  },
  saveBtn: {
    alignItems: "center",
    backgroundColor: "#006EB9",
    padding: 10,
    borderWidth: 1,
    borderColor: "#006EB9",
    width: "20%",
    marginRight: 10,
  },
  btnText: {
    color: "#fff",
    fontWeight: "600",
  },
  datePicker: {
    justifyContent: "center",
    alignItems: "flex-start",
    width: 320,
    height: 260,
    display: "flex",
  },
  card: {

    width: "100%",
    flex: 1,
    marginVertical: 0,
  },
  error_text1: {
    color: "red",
    fontSize: 10,
    fontWeight: "600",
    marginLeft: 0,
  },
  shadowProp: {
    shadowColor: "#171717",
    shadowOffset: { width: -2, height: 4 },
    shadowOpacity: 0.2,
    shadowRadius: 25,
  },

  link: {
    marginTop: 15,
    paddingVertical: 15,
  },
  error_text: {
    color: "red",
    fontSize: 14,
    fontWeight: "600",
    width: "70%",
    marginLeft: 0,
    marginBottom: 10,
  },
  linkText: {
    fontSize: 14,
    color: "#2e78b7",
  },

  dropdown: {
    borderColor: "#c3c3c3",
    width: "70%",
    borderWidth: 1,
    borderRadius: 2,
    height: 40,
    outlineStyle: "none",
    padding: 10,
    marginTop: 5,
    marginBottom: 5,

  },
  icon: {
    marginRight: 5,
  },
  item: {
    padding: 9,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  textItem: {
    flex: 1,
    fontSize: 16,
  },
  placeholderStyle: {
    fontSize: 16,
  },
  selectedTextStyle: {
    fontSize: 16,
  },
  iconStyle: {
    width: 20,
    height: 20,
  },
  inputSearchStyle: {
    height: 40,
    fontSize: 16,
  },
  lableText: {
    color: "#484848",
    fontWeight: "700",
    marginTop: 0,
  },
});
